<div class="wrapper">
  <div id="aqChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #aqChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>AQ graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
    </div>
  }
</div>